//@flow
import * as React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';
import { Text } from '@locus-taxy/neo-ui';
import { ButtonWithPopover } from 'common/components/core/button';
import { PopoverTriggerEnum } from 'common/components/core/popover/popOverFactory';

type Props = {
    overflowButtonLabel?: string
};

export class IntersectionObserverButton extends React.PureComponent<
    Props,
    void
> {
    render() {
        const {
            theme,
            showButton,
            popoverPlace,
            popoverClassName,
            popoverPreferPlace,
            invertPopover,
            invisibleElements,
            onButtonClick,
            icon,
            label,
            ripple,
            getRef,
            'data-test-id': dataTestId,
            t,
            showOverflowCount,
            overflowButtonLabel = 'moreText'
        } = this.props;
        return showButton ? (
            <ButtonWithPopover
                data-test-id={dataTestId}
                ref={getRef}
                ripple={ripple}
                theme={theme}
                place={popoverPlace}
                preferPlace={popoverPreferPlace}
                popOverClassName={classnames(theme.intersectionPopover, {
                    [popoverClassName]: popoverClassName
                })}
                invertPopover={invertPopover}
                popOverContent={invisibleElements}
                triggerPopoverOn={PopoverTriggerEnum.Click}
                icon={showOverflowCount ? null : icon}
                label={label}
                className={classnames(theme.overflowBtn, {
                    [theme.buttonWithLabel]: label,
                    [theme.overflowCountButton]: showOverflowCount
                })}
                onClick={onButtonClick}
            >
                {showOverflowCount ? (
                    <Text color="blue.400" fontWeight="bold" fontSize={1}>
                        {t(overflowButtonLabel, {
                            count: invisibleElements.length
                        })}
                    </Text>
                ) : (
                    []
                )}
            </ButtonWithPopover>
        ) : null;
    }
}
export default translate()(IntersectionObserverButton);
